<template>
  <div :class="`media-item media-item--${type}`"><slot></slot></div>
</template>

<script>
export default {
  name: 'media-item',
  props: {
    type: { type: String, required: false, default: 'image' },
  },
};
</script>
